import React from 'react';
import { Box, Toolbar } from '@mui/material';
import Navigation from './Navigation';
import Footer from './Footer';

/**
 * Main layout component for the application
 * Includes navigation and footer with main content area
 * 
 * @param {Object} props Component props
 * @param {JSX.Element} props.children Child components to render in the main content area
 * @returns {JSX.Element} Layout component
 */
const Layout = ({ children }) => {
  const drawerWidth = 240;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Navigation />
      
      {/* Main content area */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: 0, // Remove left margin
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          borderLeft: '1px solid rgba(0, 0, 0, 0.08)',
          position: 'relative',
          transition: 'all 0.2s ease-in-out'
        }}
      >
        <Toolbar /> {/* Spacer to push content below app bar */}
        <Box sx={{ 
          flexGrow: 1, 
          p: 0, // Remove padding
          '& > *': { // Apply styles to direct children
            maxWidth: '100%',
            width: '100%'
          }
        }}> 
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default Layout; 